// src/constants/horizonConstants.js

// =============================================================================
// 1. SINIR (BOUNDARY)
// =============================================================================
export const SINIR_BELIRGINLIK_OPTIONS = [
  "Belirli",
  "Geçişli",
  "Keskin",
  "Yaygın",
];

export const SINIR_SEKIL_OPTIONS = ["Dalgalı", "Düzensiz", "Düz", "Kırıklı"];

// =============================================================================
// 2. FİZİKSEL ÖZELLİKLER (TEKSTÜR)
// =============================================================================
export const TEKSTUR_OPTIONS = [
  "C (Kil)",
  "CL (Killi Tın)",
  "FLS (İnce Tınlı Kum)",
  "L (Tın)",
  "LFS (Tınlı İnce Kum)",
  "LS (Tınlı Kum)",
  "S (Kum)",
  "SC (Kumlu Kil)",
  "SCL (Kumlu Killi Tın)",
  "SiC (Siltli Kil)",
  "SiCL (Siltli Killi Tın)",
  "SiL (Siltli Tın)",
  "SL (Kumlu Tın)",
  "VFLS (Çok İnce Tınlı Kum)",
];

// =============================================================================
// 3. STRÜKTÜR (YAPI)
// =============================================================================
// Derece (Grade)
export const STRUKTUR_DAYANIKLILIK = [
  "Çok Zayıf",
  "Zayıf",
  "Orta Kuvvetli",
  "Çok Kuvvetli",
];

// Büyüklük (Class)
export const STRUKTUR_BUYUKLUK = [
  "Çok Küçük",
  "Küçük",
  "Orta Kaba",
  "Çok Kaba",
];

// Tip (Type)
export const STRUKTUR_TIP = [
  "Furda",
  "Granüler",
  "Köşeli Blok",
  "Levha",
  "Masif",
  "Prizmatik",
  "Sütunsu",
  "Taneli",
  "Yarı Köşeli Blok",
];

// =============================================================================
// 4. KIVAM (CONSISTENCY)
// =============================================================================
// Kuru (Dry)
export const KIVAM_KURU = [
  "Dağınık",
  "Yumuşak",
  "Hafif Sert",
  "Sert",
  "Çok Sert",
];

// Nemli (Moist)
export const KIVAM_NEMLI = [
  "Dağınık",
  "Gevşek",
  "Sıkı",
  "Çok Sıkı",
  "Aşırı Sıkı",
];

// Yaş (Wet) - Yapışkanlık
export const KIVAM_YAS_YAPISKANLIK = [
  "Yapışkan Değil",
  "Az Yapışkan",
  "Yapışkan",
  "Çok Yapışkan",
];

// Yaş (Wet) - Plastiklik
export const KIVAM_YAS_PLASTIKLIK = [
  "Plastik Değil",
  "Az Plastik",
  "Plastik",
  "Çok Plastik ",
];

// =============================================================================
// 5. KİMYASAL VE DİĞER
// =============================================================================
export const KIREC_OPTIONS = ["Hiç Yok", "Görünebilir", "Zayıf", "Kuvvetli"];

// Horizon içindeki taşlılık (Yüzeyden farklıdır)
export const TASLILIK_HORIZON_OPTIONS = [
  "Taşsız",
  "Az Taşlı",
  "Taşlı",
  "Çok Taşlı",
];

// =============================================================================
// 6. KÖK DAĞILIMI (ROOTS)
// =============================================================================
export const KOK_CESIT_OPTIONS = ["Saçak", "Kazık"];

export const KOK_MIKTAR_OPTIONS = [
  "Yok",
  "Çok Seyrek",
  "Seyrek",
  "Yaygın",
  "Çok Yaygın",
];

export const KOK_KALINLIK_OPTIONS = [
  "Çok İnce",
  "İnce",
  "Orta",
  "Kaba",
  "Çok Kaba",
];

// Resim 1'den alınan Renk Sınıfları (Hue)
export const MUNSELL_HUE_OPTIONS = [
  // Kırmızı (R) Grubu
  "5 R",
  "7,5 R",
  "10 R",
  // Sarı-Kırmızı (YR) Grubu
  "2,5 YR",
  "5 YR",
  "7,5 YR",
  "10 YR",
  // Sarı (Y) Grubu
  "2,5 Y",
  "5 Y",
  "10 Y",
  // Diğer / Gley
  "GLEY 1",
  "GLEY 2",
  "5 GY",
  "WH-",
];

// Resim 2'den alınan Renk Kodları (Value/Chroma)
export const MUNSELL_VALUE_CHROMA_OPTIONS = [
  "8/1",
  "8/2",
  "8/3",
  "8/4",
  "8/6",
  "8/8",
  "7/1",
  "7/2",
  "7/3",
  "7/4",
  "7/6",
  "7/8",
  "6/1",
  "6/2",
  "6/3",
  "6/4",
  "6/6",
  "6/8",
  "5/1",
  "5/2",
  "5/3",
  "5/4",
  "5/6",
  "5/8",
  "4/1",
  "4/2",
  "4/3",
  "4/4",
  "4/6",
  "4/8",
  "3/1",
  "3/2",
  "3/3",
  "3/4",
  "3/6",
  "3/8",
  "2/2",
  "2/1",
  "2.5/1",
  "2.5/2",
  "2.5/3",
  "2.5/4",
  "2.5/6",
  "8/10G",
  "7/10G",
  "6/10G",
  "5/10G",
  "4/10G",
  "3/10G",
  "2.5/10G",
  "8/5BG",
  "7/5BG",
  "6/5BG",
  "5/5BG",
  "4/5BG",
  "3/5BG",
  "2.5/5BG",
  "8/10BG",
  "7/10BG",
  "6/10BG",
  "5/10BG",
  "4/10BG",
  "3/10BG",
  "2.5/10BG",
  "8/5B",
  "7/5B",
  "6/5B",
  "5/5B",
  "4/5B",
  "3/5B",
  "2.5/5B",
  "8/10B",
  "7/10B",
  "6/10B",
  "5/10B",
  "4/10B",
  "3/10B",
  "2.5/10B",
  "8/5PB",
  "7/5PB",
  "6/5PB",
  "5/5PB",
  "4/5PB",
  "3/5PB",
  "2.5/5PB",
  "8/N",
  "7/N",
  "6/N",
  "5/N",
  "4/N",
  "3/N",
  "2.5/N",
  "8/10Y",
  "7/10Y",
  "6/10Y",
  "5/10Y",
  "4/10Y",
  "3/10Y",
  "2.5/10Y",
  "8/5GY",
  "7/5GY",
  "6/5GY",
  "5/5GY",
  "4/5GY",
  "3/5GY",
  "2.5/5GY",
  "8/10GY",
  "7/10GY",
  "6/10GY",
  "5/10GY",
  "4/10GY",
  "3/10GY",
  "2.5/10GY",
  "8/5G",
  "7/5G",
  "6/5G",
  "5/5G",
  "4/5G",
  "3/5G",
  "2.5/5G",
  "8/5G2",
  "7/5G2",
  "6/5G2",
  "5/5G2",
  "4/5G2",
  "3/5G2",
  "2.5/5G2",
];

// =============================================================================
// 7. HORİZON VERİ ŞABLONU (TEMPLATE)
// =============================================================================
export const HORIZON_TEMPLATE = {
  no: "",
  sembol: "", // Ap, Bt, C...

  // Derinlik
  derinlik_min: 0,
  derinlik_max: "",
  derinlik_arti: false, // <-- BUNU EKLE (Checkbox durumu için)

  // Sınır
  sinir_belirginlik: "",
  sinir_sekil: "",

  // Fiziksel (Renk & Tekstür)
  renk_sinif_kuru: "", // Kuru Renk Sınıfı (Hue)
  renk_kod_kuru: "", // Kuru Renk Kodu (Value/Chroma)
  renk_sinif_yas: "", // Yaş Renk Sınıfı (Hue)
  renk_kod_yas: "", // Yaş Renk Kodu (Value/Chroma)
  tekstur: "",

  // Strüktür (Yapı)
  struktur_dayaniklilik: "", // Grade
  struktur_buyukluk: "",
  struktur_tip: [], // <-- BURAYI "" YERİNE [] YAP (Dizi olmalı)

  // Kıvam
  kivam_kuru: "",
  kivam_nemli: "",
  kivam_yas_yapiskanlik: "", // Yapışkanlık
  kivam_yas_plastiklik: "", // Plastiklik

  // Kimyasal & Diğer
  kirec: "",
  taslilik: "",

  // Kök Dağılımı (Daha detaylı yapı)
  kok_sacak_miktar: "",
  kok_sacak_kalinlik: "",
  kok_kazik_miktar: "",
  kok_kazik_kalinlik: "",

  ozel_gorunum: "",
};
